module.exports = __webpack_public_path__ + "static/img/cyber-wagon_256.c244506.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cyber-wagon_256.png
// module id = taev
// module chunks = 0